import React from 'react';
import { Badge, Button, Tooltip } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

/**
 * Opens the filter panel, and says how much is in it.
 *
 * `compact` drops the label for the icon alone — for a column header, where the
 * button has a track to fit into rather than a bar.
 */
const FilterButton = ({
    label = 'Filters',
    count = 0,
    compact,
    onClick,
    dataCy = 'filter-button',
}: {
    label?: string;
    /** how many filters the panel is holding */
    count?: number;
    compact?: boolean;
    /** omit where whatever this sits in — a popover, say — owns the toggling */
    onClick?: () => void;
    dataCy?: string;
}) => {
    const button = (
        <Badge count={count} size="small" offset={[-2, 2]}>
            <Button
                className={`ft-more${compact ? ' ft-more--compact' : ''}`}
                data-cy={dataCy}
                icon={<FilterOutlined />}
                aria-label={label}
                onClick={onClick}
            >
                {compact ? null : label}
            </Button>
        </Badge>
    );

    return compact ? <Tooltip title={label}>{button}</Tooltip> : button;
};

export default FilterButton;
